import * as React from 'react';
import clsx from 'clsx';

import { InputAddUser } from 'src/models/team.model';
import { Avatar } from 'src/components/Avatar';
import { WarningIconBadge } from 'src/components/IconBadge';
import { P3, P4, P5 } from 'src/components/Typography';
import { t } from 'src/tools/text.tools';
import { ifTrue } from 'src/tools/logic.tools';
import { CloseButton } from 'src/components/Button';
import { ID } from 'src/models';
import RoleDropdown from '../RoleDropdown';
import { ResourceData } from 'src/models/modal.model';

import classes from './AssignMember.module.scss';

const TXT = t(['members', 'assignMember']);

interface Props {
  user: InputAddUser;
  onDelete: () => void;
  onChange: (user: InputAddUser) => void;
  resource: ResourceData;
}

export function AssignMember({ user, onChange, onDelete, resource }: Props) {
  const { picture, name, company, new_company, email } = user.details;

  function handleOnChange(role_id: ID, role_name: string) {
    onChange({ ...user, role_id, role_name });
  }

  function renderWarning() {
    return (
      <div className={clsx(classes.warning, 'row a-center items-p8')}>
        <WarningIconBadge isSmall />
        <P5>{`${company} ${TXT('companyWillBeAssigned')} ${name}`}</P5>
      </div>
    );
  }

  return (
    <div className={clsx(classes.container, 'column items-p8 w-100p')}>
      <div className='row a-center'>
        <Avatar className={classes.avatar} author={{ photo_url: picture, full_name: name }} />
        <div className={clsx(classes.details, 'column items-p4 f-1')}>
          <P3>{name}</P3>
          <P4 className='row items-1p6'>
            {ifTrue(company, <span>{company}</span>)}
            <span>{email}</span>
          </P4>
        </div>
        <RoleDropdown value={user.role_id} name={user.role_name} resource={resource} onChange={handleOnChange} />
        <CloseButton className={classes.close} onClick={onDelete} />
      </div>
      {ifTrue(new_company, renderWarning)}
    </div>
  );
}
